import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { GALoggerService } from 'src/app/share/service/galogger.service';
import { Directive, HostListener, Input } from '@angular/core';
import { LockDirective } from './lock-until.directive';
import { parseQueryPqrams } from 'src/app/util';

@Directive({
  selector: '[appLogHitCount]'
})
export class LogHitCountDirective {
  /** 按鈕鎖 */
  @Input('logLock') lock: LockDirective;
  /** 如果不是在anchor標籤上使用指令，就自己塞入要打日誌的資料 */
  @Input('appLogHitCount') logPayload: any;

  constructor(
    private gALoggerService: GALoggerService,
    private serverConfigService: ServerConfigService,
  ) { }

  @HostListener('click', ['$event'])
  onClick(e: UIEvent) {
    const el = e.currentTarget as HTMLElement;
    if (el instanceof HTMLAnchorElement) {
      const url = el.href;
      if (url.indexOf('subject') !== -1) {
        // 主題
        const id = url.replace(location.origin, '').split('/')[3];
        this.log({event: 'click_theme', page_id: id});
      } else {
        // 素材
        const queryParams = parseQueryPqrams(url);
        this.log({event: 'click_material', page_id: queryParams['id'], fetch_index: queryParams['indexCode']});
      }
    } else if (this.logPayload) {
      this.log(this.logPayload);
    }
  }

  private log(payload: any) {
    if (this.lock) {
      if (this.lock.isLock) {
        return;
      }
      this.lock.lock();
      this.gALoggerService.log(payload);
      this.lock.unlock();
    } else {
      this.gALoggerService.log(payload);
    }
  }
}
